import React, { useState, useEffect } from 'react';
import { Button, Input } from 'reactstrap';
import DraggablePreview from './DraggablePreview';

const Desktop = (props) => {
    const {
        TitlePath,
        DescriptionPath,
        DatePath,
        activeFilter,
        submitting,
        handleChangeFilter,
        deletePath,
        onSubmit,
        renderFrame,
        onDrag,
        feedName,
        getPreview,
        loadScripts,
        usage_js,
        handleFeedNameChange,
        selectionType,
    } = props;
    //const [isOpen, handleToolTip] = useState(false);
    const [openPreview, setOpenPreview] = useState(false);
    const [isFirstPreviewOpenTriggers, setIsFirstPreviewOpenTriggers] = useState(false);

    useEffect(() => {
        console.log(TitlePath)
        if(!isFirstPreviewOpenTriggers) {
            console.log('VS OPEN TRIGGER')
            setOpenPreview(true);
            setIsFirstPreviewOpenTriggers(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [TitlePath])

    return (
        <div className="preview" style={{/* maxHeight: 'calc(100vh - 95px)',*/ width: '100%' }}>
            {TitlePath && openPreview && (
                <DraggablePreview
                    handleOpen={setOpenPreview}
                    onDrag={onDrag}
                    TitlePath={TitlePath}
                    DatePath={DatePath}
                    DescriptionPath={DescriptionPath}
                    getPreview={getPreview}
                    changeSelectionType={() => props.changeSelectionType(selectionType === '1' ? '2' : '1')}
                    selectionType={selectionType}
                />
            )}
            <div className="flex-centered" style={{ width: '100%', marginTop: '5px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', width: '28%' }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ width: '110px' }}>
                            Newsfeed name
                        </div>
                        <Input
                            onChange={(e) => handleFeedNameChange(e.target.value)}
                            value={feedName}
                            placeholder="Enter Newsfeed Name"
                            type="text"
                            style={{ border: '1px solid #777777', width: '100%' }}
                        /> 
                    </div>
                    <Button 
                        style={{ minWidth: '85px', marginLeft: '5px' }}
                        className="calltoaction-button"
                        // disabled={!(TitlePath && /*(LinkPath && (DescriptionPath || DatePath)) &&*/ feedName.trim().length > 0)}
                        disabled={!(TitlePath && feedName && feedName.trim().length > 0)}
                        onClick={(TitlePath && feedName && feedName.trim().length > 0) ? (e) => onSubmit(e) : ()=>{}}
                    >
                        {submitting ? <i className="fa fa-spinner fa-spin" /> : 'Generate'}
                    </Button>
                </div>  
                  
            </div>
            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                <div style={{ width: '28%' }}>
                    <div style={{ width: '170px' }}>
                        News selection type
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Input
                            type="select"
                            name="select"
                            style={{ border: '1px solid #777777'}}
                            onChange={(e) => props.changeSelectionType(e.target.value)}
                            autoComplete="off"
                            value={selectionType}
                        >
                            <option value={1}>Option 1 (classes)</option>
                            <option value={2}>Option 2 (not recomended)</option>
                        </Input>
                        <i 
                            style={{ color: 'black', cursor: 'pointer', margin: '0 5px' }} 
                            className="fas fa-question-circle" 
                            aria-hidden="true"
                            id="seletionType-tooltip" 
                        />
                        <UncontrolledTooltip 
                            placement="top" 
                            target="seletionType-tooltip"
                            delay={{ show: 400, hide: 0 }} 
                            style={{ border: '1px solid black' }}
                        >
                            News were selected incorrectly? Try to change selection type and try again
                        </UncontrolledTooltip>
                    </div>
                </div>
            </div> */}
            <div className="preview-header" style={{ marginBottom: '5px' }}>
                <div style={{ width: '25%', display: 'flex', justifyContent: 'flex-end', height: '61px' }}>
                    {usage_js === false && ( 
                        <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div>Missing content?</div>
                            <Button 
                                style={{
                                    padding: '0 12px', 
                                    height: '30px' 
                                }}
                                onClick={(e) => loadScripts(e)}
                                className="typical-button"
                            >
                                Load page scripts
                            </Button>
                        </div>
                    )}
                    {/* <div style={{ width: '190px', marginLeft: '15px' }}>
                        <div style={{ width: '166px', textAlign: 'center' }}>
                            News selection type
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Input
                                type="select"
                                name="select"
                                style={{ border: '1px solid #777777', height: '30px' }}
                                onChange={(e) => props.changeSelectionType(e.target.value)}
                                autoComplete="off"
                                value={selectionType}
                            >
                                <option value={1}>Option 1 (classes)</option>
                                <option value={2}>Option 2 (not recomended)</option>
                            </Input>
                            <i 
                                style={{ color: 'black', cursor: 'pointer', margin: '0 5px' }} 
                                className="fas fa-question-circle" 
                                aria-hidden="true"
                                id="seletionType-tooltip" 
                            />
                            <UncontrolledTooltip 
                                placement="top" 
                                target="seletionType-tooltip"
                                delay={{ show: 400, hide: 0 }} 
                                style={{ border: '1px solid black' }}
                            >
                                News were selected incorrectly? Try to change selection type and try again
                            </UncontrolledTooltip>
                        </div>
                    </div> */}
                </div>
                <div style={{ width: '50%' }}>
                    <div className="optional-title">
                        <div className={activeFilter === 'Title' ? 'title-active' : 'title-unactive'} />
                        <div className={activeFilter === 'Description' || activeFilter === 'Date' ? 'optional-active optional-flex' : 'optional-unactive optional-flex'}>
                            <div />
                                <span>optional</span>
                            <div />
                        </div>
                        <div style={{ width: '10%' }} />
                    </div>
                    <div className="preview-btns">
                        <div onClick={() => handleChangeFilter('Title')} className={`preview-btns-item optional ${activeFilter === 'Title' ? 'active' : ''}`}>
                            <div className="arrow-left" />
                            <span>Title</span>
                            {TitlePath && (
                                <div onClick={() => deletePath('Title', true)} className="checkbox">
                                    <i style={{ color: '#314784' }} className="fas fa-check" />
                                </div>
                            )}
                            <div className={activeFilter === 'Title' ? 'arrow-active' : 'arrow'} />
                        </div>
                        <div 
                            onClick={() => handleChangeFilter('Description')}
                            className={`preview-btns-item optional ${activeFilter === 'Description' ? 'active' : ''}`}
                        >
                            <div className="arrow-left" />
                            <span>Abstract</span>
                            {DescriptionPath && (
                                <div onClick={() => deletePath('Description')} className="checkbox">
                                    <i style={{ color: '#314784' }} className="fas fa-check" />
                                </div>
                            )}
                            <div className={activeFilter === 'Description' ? 'arrow-active' : 'arrow'} />
                        </div>
                        <div className={`preview-btns-item optional ${activeFilter === 'Date' ? 'active' : ''}`} onClick={() => handleChangeFilter('Date')}>
                            <div className="arrow-left" />
                            <span>Date</span>
                            {DatePath && (
                                <div onClick={() => deletePath('Date')} className="checkbox">
                                    <i style={{ color: '#314784' }} className="fas fa-check" />
                                </div>
                            )}
                            <div className={activeFilter === 'Date' ? 'arrow-active' : 'arrow'} />
                        </div>
                    </div>
                </div>
                <div style={{ width: '25%', display: 'flex', justifyContent: 'flex-start', height: '61px' }}>
                    {TitlePath && (
                        <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <div>&nbsp;See Newsfeed before generating</div>
                            <Button onClick={() => setOpenPreview(prevState => !prevState)}
                                style={{ 
                                    padding: '0 24px', 
                                    height: '30px' 
                                }}
                                id="preview-btn"
                                className="typical-button"
                            >
                                {/*<i style={{ color: 'white' }} className="fas fa-eye" />*/}
                                Preview
                            </Button>
                            {/*<UncontrolledTooltip isOpen={isOpen} style={{ border: '1px solid black' }} delay={{ show: 100 }} placement="bottom" target="preview-btn">
                                Click to Preview
                            </UncontrolledTooltip>*/}
                        </div>
                    )}
                    {/*(TitlePath || DatePath || DescriptionPath) && (
                        <React.Fragment>
                            <Button
                                onClick={() => {
                                    handleOpen(!openPreview);
                                    handleToolTip(false);
                                }}
                                onMouseOver={() => handleToolTip(true)}
                                onMouseLeave={() => handleToolTip(false)}
                                id="preview-btn"
                            >
                                <i style={{ color: 'white' }} className="fas fa-eye" />
                            </Button>
                            <UncontrolledTooltip isOpen={isOpen} style={{ border: '1px solid black' }} delay={{ show: 100 }} placement="bottom" target="preview-btn">
                                Click to Preview
                            </UncontrolledTooltip>
                        </React.Fragment>
                    )*/}
                </div>
            </div>
            <div 
                className="preview-main" 
                style={props.isCompanies ? { height: 'calc(100vh - 260px)' } : {}}
            >
                {renderFrame()}
            </div>
        </div>
    );
};

export default Desktop;
